
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  CandidateResult,
  ReportShowConfigV5Item
} from "@/lib/model/exam/result";
import { CandidateNewResult } from "@/lib/model/exam/candidate-result";

enum cheatEnum {
  "screenshotDetection" = "小程序防截屏",
  "jumpOutDetection" = "小程序防切屏",
  "replacementPerson" = "换人检测",
  "webJump" = "Web防切屏",
  "faceShowDetection" = "露脸检测",
  "faceDetection" = "人脸核验",
  "multiplePersonDetection" = "多人检测",
  "livenessRecognition" = "人脸核验",
  "readingDetection" = "念稿检测",
  "keyboardSoundDetection" = "键盘声音检测",
  "multiVoiceDetection" = "多人声音检测"
}

const cheatKeys = [
  "livenessRecognition",
  "screenshotDetection",
  "mobileJoinCount",
  "replacementPerson",
  "jumpOutDetection",
  "faceShowDetection",
  "faceDetection",
  "multiplePersonDetection",
  "readingDetection",
  "keyboardSoundDetection",
  "multiVoiceDetection"
];

//异常项 默认文案
const errorEnumText = ["未检测", "未通过", "通过"];

//异常项 对应文案 详情用
const errorEnumTextEX = {
  faceDetection: ["未进行人脸核验", "人脸核验异常", "通过"],
  replacementPerson: ["未进行换人检测", "换人检测异常", "通过"],
  faceShowDetection: ["未进行露脸检测", "露脸检测异常", "通过"],
  jumpOutDetection: ["未进行防切屏检测", "切屏异常", "通过"],
  screenshotDetection: ["未进行防截屏检测", "截屏异常", "通过"],
  mobileJoinCount: ["未进行防切屏检测", "切屏异常", "通过"],
  multiplePersonDetection: ["未进行多人检测", "多人检测异常", "通过"],
  readingDetection: ["样本不足无法检测", "念稿检测异常", "通过"],
  keyboardSoundDetection: ["未进行键盘声音检测", "检测到键盘音", "通过"],
  multiVoiceDetection: ["未进行多人声音检测", "检测到多人声音", "通过"]
};

@Component({})
export default class PaperResultReport extends Vue {
  @Prop() index!: number;
  @Prop({ default: () => new CandidateNewResult() }) all!: CandidateNewResult;
  @Prop({ default: () => new ReportShowConfigV5Item() })
  option!: ReportShowConfigV5Item;
  connectCode = "";
  cheatList: any = [];

  @Watch("all")
  getAll(nval: CandidateResult) {
    this.getCheatList();
  }

  created() {
    //
    // this.getCheatList()
  }

  //
  mounted() {
    this.getCheatList();
    // this.connectCode = this.$route.query.connectCode as string;
    // this.isStudent = String(this.$route.query.ver || "") === "1";
  }

  showFaceDetectMoreImg = false;
  showMoreImg = false;
  showMoreMultipleImg = false;

  get faceDetectImageList() {
    if (this.faceDetectionResult) {
      return [...this.all.report.faceShowDetection.successImgUrlList].filter(
        item => !!item
      );
    } else {
      return [...this.all.report.faceShowDetection.errorImgUrlList].filter(
        item => !!item
      );
    }
  }

  get replaceImageList() {
    if (this.replacePersonResult) {
      return [...this.all.report.replacementDetection.successImgUrlList].filter(
        item => !!item
      );
    } else {
      return [
        this.all.report.replacementDetection.baseImgUrl,
        ...this.all.report.replacementDetection.errorImgUrlList
      ].filter(item => !!item);
    }
  }

  get multipleImageList() {
    if (this.multiplePersonResult) {
      return [
        ...this.all.report.multiplePersonDetection.successImgUrlList
      ].filter(item => !!item);
    } else {
      return [
        ...this.all.report.multiplePersonDetection.errorImgUrlList
      ].filter(item => !!item);
    }
  }

  //是否折叠图片 露脸检测截图
  get showFaceDetectMoreBtn() {
    return (
      this.faceDetectImageList.length > 6 &&
      !this.showFaceDetectMoreImg &&
      this.hasFaceDetection
    );
  }

  //是否折叠图片 换人检测
  get showMoreBtn() {
    return (
      this.replaceImageList.length > 6 &&
      !this.showMoreImg &&
      this.hasReplacePerson
    );
  }

  get showMoreMultipleBtn() {
    return (
      this.multipleImageList.length > 6 &&
      !this.showMoreMultipleImg &&
      this.hasMultiplePerson
    );
  }

  //展示出的图片 露脸检测截图
  get getFaceDetectImgList() {
    if (this.showFaceDetectMoreBtn) {
      return this.faceDetectImageList.slice(0, 6);
    } else {
      return this.faceDetectImageList;
    }
  }

  //展示出的图片 换人检测
  get getImgList() {
    if (this.showMoreBtn) {
      return this.replaceImageList.slice(0, 6);
    } else {
      return this.replaceImageList;
    }
  }

  get getMultipleImgList() {
    if (this.showMoreMultipleBtn) {
      return this.multipleImageList.slice(0, 6);
    } else {
      return this.multipleImageList;
    }
  }

  // 是否包含露脸检测且检测过
  get hasFaceDetection() {
    const faceDetection = this.cheatList.filter(
      (el: any) => el.task === "faceShowDetection"
    );
    return faceDetection.length > 0 && faceDetection[0].type !== 0;
  }

  // 露脸检测的结果 true 通过  false 不通过
  get faceDetectionResult() {
    const detection = this.cheatList.filter(
      (el: any) => el.task === "faceShowDetection"
    );
    if (detection.length > 0) {
      // 其他 通过，1 不通过
      return detection[0].type !== 1;
    }
    return true;
  }

  get hasFaceCheck() {
    const faceCheck = this.cheatList.filter(
      (el: any) => el.task === "faceCheck"
    );
    return (
      faceCheck.length > 0 &&
      faceCheck[0].type === 2 &&
      this.all.report.livenessRecognition.imgUrl
    );
  }

  // 是否包含换人检测且检测过
  get hasReplacePerson() {
    const replacePerson = this.cheatList.filter(
      (el: any) => el.task === "replacementPerson"
    );
    return replacePerson.length > 0 && replacePerson[0].type !== 0;
  }

  // 换人检测的结果 true 通过  false 不通过
  get replacePersonResult() {
    const detection = this.cheatList.filter(
      (el: any) => el.task === "replacementPerson"
    );
    if (detection.length > 0) {
      // 其他 通过，1 不通过
      return detection[0].type !== 1;
    }
    return true;
  }

  get hasMultiplePerson() {
    const multiplePerson = this.cheatList.filter(
      (el: any) => el.task === "multiplePersonDetection"
    );
    return multiplePerson.length > 0 && multiplePerson[0].type !== 0;
  }

  // 多人检测的结果 true 通过  false 不通过
  get multiplePersonResult() {
    const detection = this.cheatList.filter(
      (el: any) => el.task === "multiplePersonDetection"
    );
    if (detection.length > 0) {
      // 其他 通过，1 不通过
      return detection[0].type !== 1;
    }
    return true;
  }

  openImg(url: string) {
    this.$emit("openImg", url);
  }

  getCheatList() {
    this.cheatList = [];
    this.all.report.errorInfoList.forEach(item => {
      if (cheatKeys.includes(item.task)) {
        let resMessage = "";
        if (item.task === "livenessRecognition" && item.result === 1) {
          resMessage = this.all.report.livenessRecognition?.msg || "";
        }
        if (item.task === "readingDetection" && item.result === 1) {
          resMessage =
            this.all.report.readingDetection.resultStatus === 2
              ? "高风险-疑似念稿行为概率较高"
              : "中风险-疑似存在念稿行为";
        }
        this.cheatList.push({
          name: cheatEnum[item.task],
          type: item.result,
          task: item.task,
          result: errorEnumText[item.result],
          value:
            resMessage ||
            item.resMessage ||
            errorEnumTextEX?.[item.task]?.[item.result] ||
            errorEnumText[item.result]
        });
      }
    });
    console.log(this.cheatList);
    this.$emit("getCheatList", this.cheatList);
  }

  async wait(secends: number) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(true);
      }, secends);
    });
  }
}
